import React from 'react'

import { Box, HorizontalScroll, Text } from '@vividseats/vivid-ui-kit'

import ReviewCard from './components/review-card'
import styles from './styles.module.scss'

const reviews = [
    {
        name: 'Brad B.',
        title: 'Vivid Seats Ticket Buyer',
        numStars: 5,
        reviewText: 'Great every time! 11th ticket is free as well. Absolutely, will not buy tickets anywhere else.',
    },
    {
        name: 'Adam M.',
        title: 'Vivid Seats Ticket Buyer',
        numStars: 5,
        reviewText:
            'Reliable, worry free, and credits earned from past events had paid entirely for tickets to an NFL playoff game.',
    },
    {
        name: 'Heather Y.',
        title: 'Vivid Seats Ticket Buyer',
        numStars: 5,
        reviewText:
            'I loved the ease of use, the wonderful selection and the ability to both buy and sell tickets. The interactive screen and ability to find groups and events is so easy. Would recommend this app to anyone!',
    },
    {
        name: 'Johnbonhamfan',
        title: 'Vivid Seats Ticket Buyer',
        numStars: 5,
        reviewText: 'Always great prices and tickets come fast even the day of the game or the day before I love it',
    },
    {
        name: 'AmauriTre',
        title: 'Vivid Seats Ticket Buyer',
        numStars: 5,
        reviewText:
            'I always compare prices to other platforms and Vivid is the most competitive. Plus, the ease of using the app is great. So simple and easy to use.',
    },
    {
        name: 'Cassidy W.',
        title: 'Vivid Seats Ticket Buyer',
        numStars: 5,
        reviewText: 'this app makes it easy to buy tickets and easy access to them.',
    },
]

const RewardReviews: React.FC = () => {
    return (
        <Box className={styles.mainWrapper}>
            <Box
                display={'flex'}
                mobileJustify={'center'}
                tabletJustify={'start'}
                desktopJustify={'center'}
                mobilePaddingLeft={0}
                tabletPaddingLeft={9}
                desktopPaddingLeft={0}
            >
                <Text weight="extra-extra-bold" altFont={true} size="title-lg" className={styles.headerText} as="h2">
                    See why fans love us
                </Text>
            </Box>
            <HorizontalScroll scroll={false} classNameForHsWrapper={styles.horizontalScrollWrapper}>
                {reviews.map((review) => (
                    <ReviewCard
                        key={review.name}
                        name={review.name}
                        title={review.title}
                        numStars={review.numStars}
                        reviewText={review.reviewText}
                    />
                ))}
            </HorizontalScroll>
        </Box>
    )
}

export default RewardReviews
